module.exports = __webpack_public_path__ + "img/HC3021-74.3e00537e.jpg";